import { Section, ReadingColumn } from "@/components/luminous/interior";
import type { Lang } from "@/components/luminous/primitives";

interface CaseStudiesHubSummaryProps {
  language: Lang;
}

const content = {
  es: {
    label: "Resumen citable",
    title: "En resumen",
    points: [
      { label: "Empresas atendidas:", text: "Fabricantes industriales, marcas de consumo y empresas reguladas en Texas y México." },
      { label: "Servicios aplicados:", text: "SEO técnico, Amazon SEO y Ads, branding y desarrollo a medida, siempre priorizando por impacto en negocio." },
      { label: "Problemas resueltos:", text: "Listings sin estructura, identidad visual sin coherencia, procesos manuales sin trazabilidad." },
      { label: "Resultados observables:", text: "Datos verificables cuando existe evidencia y autorización del cliente; sin cifras sin origen." },
      { label: "Próximo paso:", text: "reunión inicial gratuita de 30 minutos para analizar tu situación específica." },
    ],
  },
  en: {
    label: "Quotable summary",
    title: "In summary",
    points: [
      { label: "Companies served:", text: "Industrial manufacturers, consumer brands and regulated companies in Texas and Mexico." },
      { label: "Services applied:", text: "Technical SEO, Amazon SEO and Ads, branding and custom development, always prioritized by business impact." },
      { label: "Problems solved:", text: "Listings without structure, visual identity without coherence, manual processes without traceability." },
      { label: "Observable results:", text: "Verifiable data when evidence and client authorization exist; no figures without a source." },
      { label: "Next step:", text: "free 30-minute initial consultation to analyze your specific situation." },
    ],
  },
} as const;

export const CaseStudiesHubSummary = ({ language }: CaseStudiesHubSummaryProps) => {
  const t = content[language];

  return (
    <Section id="resumen" index="02" label={t.label} title={t.title} tone="mineral">
      <ReadingColumn className="max-w-none">
        <dl className="border-t border-[color:var(--v3-line)]">
          {t.points.map((p) => (
            <div
              key={p.label}
              className="grid gap-1 border-b border-[color:var(--v3-line)] py-4 sm:grid-cols-[minmax(0,11rem)_1fr] sm:gap-4"
            >
              <dt className="text-[0.95rem] font-semibold text-[color:var(--v3-ink)]">
                {p.label}
              </dt>
              <dd className="text-[0.95rem] leading-relaxed text-[color:var(--v3-ink-soft)]">
                {p.text}
              </dd>
            </div>
          ))}
        </dl>
      </ReadingColumn>
    </Section>
  );
};
